import { api } from "supabase/database/api.ts";
import { BaseContent, MediaItem } from "./types";
import { redirect } from "react-router-dom";

const mediaKeys = {
    video_key: "video",
    file: "file",
    audio: "audio",
    content: "content"
}

export function normalizeMedia<T extends Record<string, any>>(
  row: T,
  order: string[]
): BaseContent {
  const media: MediaItem[] = [];

  for (const column of order) {
    const type = mediaKeys[column];
    const key = row[column as keyof T];
    if (key) media.push({ type: type!, key: key as string });
  }

  return {
    id: row.id,
    status: row.status,
    title: row.title,
    date: row.date,
    media,
  };
}

const formattedDate = (date, articles = false) => {
	try {
		const parts = date.split("-");
		if (articles)
			return `CHJN's Letter-${parseInt(parts[0]) - 1983}${parts[1]}${
				parts[2]
			}`;
		return `${parseInt(parts[0]) - 1983}${parts[1]}${parts[2]}`;
	} catch (error) {
		return null;
	}
};

const formatDate = (date) => {
		const parts = date.match(/.{1,2}/g);
		return `${parseInt(parts[0]) + 1983}-${parts[1]}-${parts[2]}`;
};

async function fetchLiveVideo(table) {
	try {
		const playlist = table === "service" ? process.env.REACT_APP_YOUTUBE_SERVICE_PLAYLIST : process.env.REACT_APP_YOUTUBE_DB_PLAYLIST
		const playlistApi = `${process.env.REACT_APP_YOUTUBE_PLAYLIST_BASE_URL}?part=snippet&maxResults=1&playlistId=${playlist}&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`;
		const response = await fetch(playlistApi);
		const data = await response.json();
		
		if (data?.items && data.items.length > 0) {
			const content = data.items[0].snippet;
			const liveData = {
				title: content.title,
				video_key: content.resourceId.videoId,
				date: formatDate(content.title.split(" ")[0]),
        thumbnail: "b73191d7-ac5f-4dab-b27d-657ef79e23a4"
			};
			return liveData;
		}
		return null;
	} catch (error) {
		console.error("Error fetching data:", error);
		return null;
	}
}

export const utils = { formattedDate, formatDate, fetchLiveVideo }